import styled from 'styled-components/macro';
import { Button } from '../../../components/Buttons';
import { colors } from '../../../styles/constants';

export const BackButton = styled(Button as any)`
    color: ${colors.text};
    background: ${colors.borderLight};
    border: ${colors.borderLight};
`;
